import { BorrowerStatus } from 'enums/curo/BorrowerStatus';
import { OfferType } from 'enums/curo/OfferType';
import { CuroApplicationVariables } from 'enums/curo/Variables';
import { getApplicationSelector } from 'handlers/curo-handlers/selectors';
import { useAppSelector } from 'hooks/reduxHooks';
import { useCurrentStep } from 'hooks/useCurrentStep';

import BranchOfferFlow from './BranchOfferFlow';
import NoCreditOfferFlow from './NoCreditOfferFlow';
import OnlineOfferFlow from './OnlineOfferFlow';
import { GenerateLoanOffersSteps } from './constants';

const GenerateLoanOffersStep = () => {
  const application = useAppSelector(getApplicationSelector)!;

  const isOldReleaseVersion =
    application.variables[CuroApplicationVariables.ReleaseVersion] === '1';
  const oldReleaseOfferType =
    application.variables[CuroApplicationVariables.BorrowerStatus] === BorrowerStatus.Existing &&
    !!application.variables[CuroApplicationVariables.SmallLoanRefiJourney]
      ? OfferType.OnlineOffer
      : OfferType.BranchOffer;

  const offerType =
    isOldReleaseVersion && !application.variables[CuroApplicationVariables.OfferType]
      ? oldReleaseOfferType
      : application.variables[CuroApplicationVariables.OfferType]!;

  const getInitialStep = () => {
    switch (offerType) {
      case OfferType.BranchOffer:
        return GenerateLoanOffersSteps.BranchOffer;
      case OfferType.NoCreditOffer:
        return GenerateLoanOffersSteps.NoCreditOffer;
      case OfferType.OnlineOffer:
        return GenerateLoanOffersSteps.OnlineOffer;
      default:
        return null;
    }
  };

  const [currentStep, setCurrentStep] = useCurrentStep<GenerateLoanOffersSteps | null>(
    getInitialStep(),
  );

  const renderCurrentStep = () => {
    switch (currentStep) {
      case GenerateLoanOffersSteps.BranchOffer:
        return <BranchOfferFlow />;
      case GenerateLoanOffersSteps.NoCreditOffer:
        return (
          <NoCreditOfferFlow
            startBranchFlow={() => setCurrentStep(GenerateLoanOffersSteps.BranchOffer)}
          />
        );
      case GenerateLoanOffersSteps.OnlineOffer:
        return <OnlineOfferFlow />;
      default:
        return null as never;
    }
  };
  return renderCurrentStep();
};

export default GenerateLoanOffersStep;
